module.exports = __webpack_public_path__ + "home/en-US/images/yellow_drag_box-2620dbe05770b0717164b3d897133430.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/yellow_drag_box.png
// module id = DTnw
// module chunks = 0